import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setSentryRouteTag } from '../../lib/sentry'

/** Houdt tag `route` (pathname) op Sentry scope bij navigatie. */
export function SentryRouteScope () {
  const { pathname } = useLocation()

  useEffect(() => {
    setSentryRouteTag(pathname)
  }, [pathname])

  return null
}
